"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _routing = require("@engaging-tech/routing");

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var Container = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "TabBar__Container",
  componentId: "sc-1da3hct-0"
})(["border-bottom:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[4];
});
var MenuGroup = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "TabBar__MenuGroup",
  componentId: "sc-1da3hct-1"
})(["justify-content:flex-start;align-items:center;overflow:auto;-webkit-overflow-scrolling:touch;"]);
var disabledStyle = (0, _styledComponents.css)(["color:", ";opacity:0.54;cursor:not-allowed;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.dark[3];
});
var TabLink = (0, _styledComponents["default"])(_routing.Link).withConfig({
  displayName: "TabBar__TabLink",
  componentId: "sc-1da3hct-2"
})(["display:block;color:", ";border-bottom:", ";height:48px;line-height:48px;padding:0 16px;text-transform:uppercase;font-size:14px;font-weight:500;flex-shrink:0;", ""], function (_ref3) {
  var theme = _ref3.theme,
      selected = _ref3.selected;
  return selected ? theme.colors.primary[0] : theme.colors.dark[2];
}, function (_ref4) {
  var theme = _ref4.theme,
      selected = _ref4.selected;
  return selected ? "2px solid " + theme.colors.primary[0] : "0px solid " + theme.colors.dark[0];
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? disabledStyle : "";
});

var Tabs = function Tabs(_ref6) {
  var routes = _ref6.routes,
      selectedTab = _ref6.selectedTab;
  return _react["default"].createElement(MenuGroup, {
    pl: [0, 0, 2],
    pt: [0, 0, 2]
  }, routes && routes.map(function (route) {
    return _react["default"].createElement(TabLink, {
      to: route.isDisabled ? null : route.path,
      key: route.path,
      disabled: !!route.isDisabled,
      selected: selectedTab === route.path
    }, route.description);
  }));
};

var TabBar = function TabBar(_ref7) {
  var routes = _ref7.routes,
      selectedTab = _ref7.selectedTab;
  return _react["default"].createElement(Container, null, _react["default"].createElement(Tabs, {
    selectedTab: selectedTab,
    routes: routes
  }));
};

var _default = TabBar;
exports["default"] = _default;